export default __webpack_public_path__ + "static/malolepszy-3f1c3cb1ef3e800d1982386bc2d5a9b9.jpg";